import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-paymentCarrier-lookup',
  templateUrl: './micro-paymentCarrier-lookup.component.html'
})
export class MicroPaymentCarrierLookupComponent  {

  @Input()
  paymentCarrierId:any;
}
